import { useRouteSection } from '@/hooks/useRouteSection';
import { useTranslation } from 'react-i18next';

export const FaqContent = () => {
  const routeSection = useRouteSection();
  const { t } = useTranslation('translation', {
    keyPrefix: 'faq',
  });


  return {
    faqContent: [
    {
      id: 1,
      title: t('claim.title'),
      content: t('claim.content')
    },

    {
      id: 2,
      title: t('cover.title'),
      content: t('cover.content')
    },

    {
      id: 3,
      title: t('cancel.title'),
      content: t('cancel.content')
    },
    
    {
      id: 4,
      title: t('contact.title'),
      content: t('contact.content')
    },
    
    {
      id: 5,
      title: t(`nomination.title.${routeSection}`),
      content: t(`nomination.content.${routeSection}`)
    },
],
  };
};



export default FaqContent;